<script setup lang="ts">
import { computed } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'
import { IncidentButtonData } from '@desktop/views/Relation/Sports/configuration'
import { injectPitchIncidentsConfig } from '@desktop/views/Relation/Sports/provide-inject'

import PitchIncidentButton from '../../PitchIncidentButton/PitchIncidentButton.vue'

interface Props {
  participant?: Participant
  reversed?: boolean
}

defineProps<Props>()

// inject
const { pitchIncidents } = injectPitchIncidentsConfig()
const { separator, gridClass, incidentButtonData, buttonHeightClass } =
  pitchIncidents

// data
const data = isNestedArray(incidentButtonData)
  ? incidentButtonData
  : [incidentButtonData]

// computed
const isIncidentButtonDataNested = computed(() =>
  isNestedArray(incidentButtonData),
)

// methods
function isNestedArray(
  array: IncidentButtonData[][] | IncidentButtonData[],
): array is IncidentButtonData[][] {
  return array.every((item) => Array.isArray(item))
}

function getGridRowClass(): string {
  return isIncidentButtonDataNested.value
    ? `grid-rows-${incidentButtonData.length}`
    : ''
}
</script>

<template>
  <div class="flex-1">
    <div
      class="gap-y-fluid grid h-full gap-x-1.5"
      :class="[gridClass, getGridRowClass()]"
      :dir="reversed ? 'rtl' : undefined"
    >
      <div
        v-if="separator"
        :class="[
          `row-start-${separator.rowStart}`,
          `col-start-${separator.colStart}`,
          `row-span-${separator.rowSpan}`,
        ]"
      />

      <template
        v-for="(row, rowIndex) in data"
        :key="rowIndex"
      >
        <template
          v-for="(cell, cellIndex) in row"
          :key="cellIndex"
        >
          <PitchIncidentButton
            v-bind="{
              ...cell,
              buttonHeightClass,
            }"
            :participant
          />
        </template>
      </template>
    </div>
  </div>
</template>
